import React, { useState } from "react";
import validationSchema from "./schema";
import { Formik, Form, ErrorMessage } from "formik";
import { Button, CircularProgress, TextField } from "@mui/material";
import PasswordField from "../PasswordField";
import { login } from "../../services/auth";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getUserById } from "../../services/user";

const LoginForm = ({ companyId, email }) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const navigateToProfile = (profile) => {
    if (!profile) {
      return;
    }
    if (profile.company) {
      navigate("/home-page", {
        state: { profile: profile },
      });
    } else {
      navigate("/form-workspace", {
        state: { profile: profile },
      });
    }
  };
  const handleSubmit = async (values) => {
    setIsLoading(true);
    const userInfo = {
      companyId: companyId || null,
      email: values.email,
      password: values.password,
    };

    try {
      const response = await login(userInfo);
      if (response) {
        toast.success("Login exitoso", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

        // Obtener los datos del usuario después del inicio de sesión exitoso
        const userProfile = await getUserById(response.userId);
        navigateToProfile(userProfile);
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Formik
      initialValues={{ email: email || "", password: "" }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({
        isSubmitting,
        handleBlur,
        handleChange,
        touched,
        errors,
        values,
      }) => (
        <Form>
          <TextField
            type="email"
            name="email"
            placeholder="Correo Electrónico"
            variant="outlined"
            fullWidth
            id="email"
            label="Correo Electrónico"
            autoComplete="email"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.email}
            disabled={email ? true : false}
            error={touched.email && !!errors.email}
            helperText={<ErrorMessage name="email" />}
            style={{ marginBottom: "16px" }}
          />
          <PasswordField
            name="password"
            placeholder="Contraseña"
            variant="outlined"
            fullWidth
            id="password"
            label="Contraseña"
            autoComplete="current-password"
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.password && !!errors.password}
            helperText={<ErrorMessage name="password" />}
          />
          {isLoading ? (
            <CircularProgress />
          ) : (
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              style={{ marginTop: "16px" }}
              disabled={isSubmitting}
            >
              Iniciar Sesión
            </Button>
          )}
        </Form>
      )}
    </Formik>
  );
};

export default LoginForm;
